<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada">
            <div class="page">
                <loading :isLoading="isLoading" />
                <div class="formularios-list vertical-flow">
                    <h1 class="title">{{ $t('formularios') }}</h1>
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li v-if="isPrestacaoServico">
                                <a class="a-inativo">
                                    {{ $t('prestacao-servico') }}
                                </a>
                            </li>
                            <li>
                                <a>
                                    {{
                                        $route.meta.abrev == 'pro' ? $t('promotor') : $t('vendas')
                                    }}</a
                                >
                            </li>
                            <li>
                                <a>
                                    {{
                                        this.$route.meta.abrev == 'pro'
                                            ? $t('relatorios')
                                            : $t('formulario')
                                    }}</a
                                >
                            </li>
                            <li>
                                <a href="#" aria-current="page">{{ $t('formularios') }}</a>
                            </li>
                        </ul>
                    </nav>

                    <div class="columns">
                        <div class="column is-6">
                            <search-bar
                                class="search-bar"
                                :onSearch="debouncedOnSearch"
                                :placeholder="$t('busca')"
                                :tooltipLabel="
                                    $t('msg-campo-busca-n', {
                                        n: `${$t('codigo')}, ${$t('titulo-formulario')}`,
                                    })
                                "
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                title="empresa"
                                placeholder="selecione-uma-opcao"
                                :options="empresaSelect"
                                v-model="empresaSelected"
                                :loading="empresaLoading"
                                @search="carregarEmpresa"
                                multiple
                                searchable
                                clearable
                                :closeOnSelect="false"
                                @onBlurFunction="carregarDados"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                v-model="selectedOrigemFormulario"
                                :options="origensFormulario"
                                title="origem"
                                @onBlurFunction="carregarDados"
                                @search="fetchOrigemFormulario"
                                :loading="isLoadingOrigensFormulario"
                                placeholder="selecione-uma-opcao"
                                clearable
                                mlLabels
                            />
                        </div>
                    </div>

                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="formularios"
                            :mobile-cards="false"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :width="f.width"
                                :label="f.label ? $t(f.label) : f.key != 'excluir' ? $t(f.key) : ''"
                                :sortable="f.sortable"
                                :centered="f.centered"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'titulo' || f.key == 'idform_formularioerp'">
                                    <router-link
                                        v-if="$route.meta.abrev == 'serv'"
                                        :to="{
                                            name: 'serv-formulario-respondido-view',
                                            params: {
                                                idFormulario: props.row.id,
                                            },
                                            query: {
                                                origem: props.row.origemFormulario,
                                            },
                                        }"
                                    >
                                        {{ props.row[f.key] }}
                                    </router-link>
                                    <router-link
                                        v-else
                                        :to="{
                                            name:
                                                $route.meta.abrev == 'pro'
                                                    ? 'formulario-respondido-view'
                                                    : 'ven-formulario-respondido-view',
                                            params: {
                                                idFormulario: props.row.id,
                                            },
                                            query: {
                                                origem: props.row.origemFormulario,
                                            },
                                        }"
                                    >
                                        {{ props.row[f.key] }}
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'origemFormulario'">
                                    {{ $t(props.row[f.key]) }}
                                </div>
                                <div v-else-if="f.key == 'versao'">
                                    {{ $moment(props.row[f.key]).format('L LT') }}
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import FilterBar from '@/components/shared/Filter';

export default {
    components: {
        FilterBar,
    },
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('formulario-respondido-view')) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }
        next();
    },
    data() {
        return {
            rotaAninhada: false,
            formularios: [],
            origensFormulario: [],
            selectedOrigemFormulario: null,
            isLoadingOrigensFormulario: false,
            empresaSelect: [],
            empresaSelected: [],
            empresaLoading: false,
            filters: {
                empresaList: [],
                origemFormulario: null,
            },
            fields: [
                { key: 'idform_formularioerp', label: 'codigo', sortable: true, width: null },
                { key: 'titulo', label: 'titulo-formulario', sortable: true },
                { key: 'versao', sortable: true },
                { key: 'origemFormulario', label: 'origem', sortable: true },
                {
                    key: 'respostasCount',
                    label: 'respostas',
                    sortable: true,
                    centered: true
                },
            ],
            column: 'versao',
            order: 'desc',
            isEmpty: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },

            isLoading: false,
            debouncedOnSearch: null,
            permissao: {},
            isPrestacaoServico: this.$route.meta.contexto == 'prestacao-servico',
        };
    },
    created() {
        this.rotaAninhada = this.$route.name.includes('formulario-respondido-view');

        if (this.$route.meta.abrev == 'serv') {
            this.permissao = this.hasPermissionAccess(
                'prestacao-servico',
                'formulario',
                'serv-formulario-respondido'
            );
        } else if (this.$route.meta.abrev == 'pro') {
            this.permissao = this.hasPermissionAccess(
                'promotor',
                'relatorios',
                'formulario-respondido'
            );
        } else if (this.$route.meta.abrev == 'ven') {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'formulario',
                'ven-formulario-respondido'
            );
        }

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'formularios' },
            });

        this.debouncedOnSearch = this.debounce(this.onSearch, 1000);
        this.carregarDados();
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.searchQuery = value;
            this.carregarDados(1);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.filters.empresaList = this.empresaSelected.map((m) => m.id);
            this.filters.origemFormulario = this.selectedOrigemFormulario
                ? this.selectedOrigemFormulario.id
                : null;

            this.isLoading = true;

            this.$axios
                .post(`/${this.$route.meta.abrev}/formRespostaCabecalho.json`, this.filters, {
                    params: {
                        column: this.column,
                        order: this.order,
                        page: currentPage - 1,
                        limit: this.pagination.perPage,
                        contexto: this.$route.meta.abrev,
                        param: this.searchQuery,
                    },
                })
                .then((response) => {
                    this.formularios = response.data.content;

                    this.pagination.totalRows = response.data.totalElements;

                    this.isEmpty = this.formularios.length <= 0;
                })
                .catch((_) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    this.isEmpty = true;
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        fetchOrigemFormulario() {
            this.isLoadingOrigensFormulario = true;

            this.$axios
                .get(`${this.$route.meta.abrev}/formRespostaCabecalho/origemFormulario.json`)
                .then((response) => {
                    this.origensFormulario = Object.entries(response.data).map(([id, label]) => ({
                        id,
                        label,
                    }));
                })
                .catch(() => {
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.isLoadingOrigensFormulario = false;
                });
        },
        carregarEmpresa(query) {
            this.empresaLoading = true;
            this.$axios
                .get(`/getcombo/empresa.json`, {
                    params: {
                        situacao: 4,
                        param: query,
                    },
                })
                .then((response) => {
                    if (response.data.content) {
                        this.empresaSelect = response.data.content.map((m) => {
                            return {
                                id: m.idempresa,
                                label:
                                    m.replicapda == 2
                                        ? 'Inativo | ' + m.nome + ' - ' + m.rsocial
                                        : m.nome + ' - ' + m.rsocial,
                                replicapda: m.replicapda,
                            };
                        });
                    }
                })
                .catch(() => {
                    console.error('Erro ao carregar empresas.');
                })
                .finally((_) => {
                    this.empresaLoading = false;
                });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }
    .formularios-list .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .formularios-list .search-and-filter .search-bar {
        width: 100%;
    }
    .formularios-list .search-and-filter .filter-bar {
        width: 31%;
    }

    .search-bar {
        height: 36px;
    }
}
</style>
